"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../../utils/constants");
var _types = require("../../utils/types");
var _ConversationHeader = _interopRequireDefault(require("../ConversationHeader/ConversationHeader"));
var _TwitterView = _interopRequireDefault(require("./TwitterView/TwitterView"));
var _ChatView = _interopRequireDefault(require("./ChatView/ChatView"));
var _MailsView = _interopRequireDefault(require("./MailView/MailsView"));
var _ImageIcon = _interopRequireDefault(require("../common/ImageIcon/ImageIcon"));
var _WrapUp = _interopRequireDefault(require("../WrapUp/WrapUp"));
var _ContactInfo = _interopRequireDefault(require("./ContactInfo/ContactInfo"));
require("./ConversationView.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var ConversationView = function ConversationView(_ref) {
  var conversation = _ref.conversation,
    _ref$conversation = _ref.conversation,
    _ref$conversation2 = _ref$conversation === void 0 ? {} : _ref$conversation,
    id = _ref$conversation2.id,
    campType = _ref$conversation2.campType,
    type = _ref$conversation2.type,
    campaign = _ref$conversation2.campaign,
    contact = _ref$conversation2.contact,
    initialTime = _ref$conversation2.initialTime,
    typing = _ref$conversation2.typing,
    messages = _ref$conversation2.messages,
    templates = _ref$conversation2.templates,
    takeover = _ref$conversation2.takeover,
    clientTermination = _ref$conversation2.clientTermination,
    clientWithHistoricalChat = _ref$conversation2.clientWithHistoricalChat,
    chatStarted = _ref$conversation2.chatStarted,
    exitWrapUpDisposition = _ref$conversation2.exitWrapUpDisposition,
    lastConversations = _ref$conversation2.lastConversations,
    timeoutReached = _ref$conversation2.timeoutReached,
    data = _ref$conversation2.data,
    _ref$draftMessages = _ref.draftMessages,
    draftMessages = _ref$draftMessages === void 0 ? {} : _ref$draftMessages,
    openMessages = _ref.openMessages,
    toggle = _ref.toggle,
    _onFinish = _ref.onFinish,
    onUnassign = _ref.onUnassign,
    onSpam = _ref.onSpam,
    onDiscard = _ref.onDiscard,
    onWrapUp = _ref.onWrapUp,
    _onSendResponse = _ref.onSendResponse,
    lang = _ref.lang,
    agent = _ref.agent,
    onAttachments = _ref.onAttachments,
    onUploadAttachments = _ref.onUploadAttachments,
    onDeleteAttachment = _ref.onDeleteAttachment,
    onShowAlertDisconexion = _ref.onShowAlertDisconexion,
    onAceptedChat = _ref.onAceptedChat,
    onDialog = _ref.onDialog,
    onLoadMessages = _ref.onLoadMessages,
    onUpdateDraftMessage = _ref.onUpdateDraftMessage,
    onUpdateDraftAttachments = _ref.onUpdateDraftAttachments,
    onDeleteDraftMessage = _ref.onDeleteDraftMessage,
    openWrapup = _ref.openWrapup,
    setTheUrlOfAttachments = _ref.setTheUrlOfAttachments,
    startConversation = _ref.startConversation,
    setStartConversation = _ref.setStartConversation,
    disabledActions = _ref.disabledActions,
    setNumFiles = _ref.setNumFiles,
    getUploadState = _ref.getUploadState;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isWrapUpOpen = _useState2[0],
    setWrapUpOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    endConversation = _useState4[0],
    setEndConversation = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isContactInfoOpen = _useState6[0],
    setContactInfoOpen = _useState6[1];
  (0, _react.useEffect)(function () {
    setContactInfoOpen(false);
  }, [id]);
  (0, _react.useEffect)(function () {
    if (clientTermination && type === _constants.TABS.CHAT) {
      _onFinish(campType, id);
    }
  }, [clientTermination]);
  (0, _react.useEffect)(function () {
    if (openWrapup) setWrapUpOpen(true);
  }, [openWrapup]);
  var mailResponseData = (0, _react.useRef)({});
  if (conversation == null) return /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-conversation-view"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-conv-view-wrapper"
  }, /*#__PURE__*/_react["default"].createElement(_ConversationHeader["default"], null), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-conv-view empty"
  })));
  var onAttachmentsHandle = function onAttachmentsHandle() {
    onAttachments(campType, id);
  };
  var onFinishHandler = function onFinishHandler() {
    _onFinish(campType, id);
    if (endConversation) {
      setEndConversation(false);
    }
    if (type !== 'WHATSAPP' || campaign.showWrapUp === undefined || campaign.showWrapUp) {
      setWrapUpOpen(true);
    }
  };
  var onWrapUpHandler = function onWrapUpHandler(disposition, messageId) {
    var obj = _objectSpread(_objectSpread({}, disposition), {}, {
      messageId: messageId
    });
    onWrapUp(campType, id, obj);
    if (exitWrapUpDisposition === undefined ? true : exitWrapUpDisposition) {
      setWrapUpOpen(false);
    }
  };
  var onUploadAttachmentsHandle = function onUploadAttachmentsHandle(files) {
    files.forEach(function (f) {
      return onUploadAttachments(campType, id, f.name, f);
    });
  };
  var onDeleteAttachmentHandle = function onDeleteAttachmentHandle(url) {
    onDeleteAttachment(campType, id, url);
  };
  var onAceptedChatHandle = function onAceptedChatHandle() {
    onAceptedChat(campType, id);
  };
  var onLoadMessagesHandle = function onLoadMessagesHandle() {
    onLoadMessages(campType, id);
  };
  var onHandleReply = function onHandleReply(messageId, subject, message, attachments, cc, bcc, IsAzure) {
    _onFinish(campType, id);
    setTimeout(function () {
      _onSendResponse(campType, id, message, messageId, subject, attachments, campaign.account, contact.account, cc, bcc, IsAzure);
    }, 500);
    setWrapUpOpen(true);
    mailResponseData.current = {
      messageId: messageId,
      subject: subject,
      message: message,
      attachments: attachments,
      cc: cc,
      bcc: bcc,
      IsAzure: IsAzure
    };
  };
  var onUnassignAndDeleteDraft = function onUnassignAndDeleteDraft() {
    onUnassign(campType, id);
    onDeleteDraftMessage(campType, id);
  };
  var messagesUser = messages.some(function (item) {
    return item.origin === _constants.MSG_SOURCE.USER;
  });
  var disabled = type === _constants.TABS.CHAT ? takeover : type === _constants.TABS.WHATSAPP && campType === _constants.CAMPTYPE.OUTBOUND ? !messagesUser : !chatStarted;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-conversation-view"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-conv-view-wrapper"
  }, /*#__PURE__*/_react["default"].createElement(_ConversationHeader["default"], {
    type: type,
    subject: messages && messages[0] && messages[0].subject,
    contact: _objectSpread(_objectSpread({}, contact), {}, {
      image: /*#__PURE__*/_react["default"].createElement(_ImageIcon["default"], {
        id: "uin-conv-header-iic",
        name: campaign.name,
        image: campaign.graphicId,
        type: campaign.type
      })
    }),
    initialTime: initialTime,
    onFinish: type === _constants.TABS.CHAT || type === _constants.TABS.WHATSAPP ? onFinishHandler : undefined,
    onUnassign: type === _constants.TABS.WHATSAPP ? undefined : onUnassignAndDeleteDraft,
    onSpam: type === _constants.TABS.MAIL ? function () {
      return onSpam(campType, id);
    } : undefined,
    onDiscard: type === _constants.TABS.CHAT || type === _constants.TABS.WHATSAPP ? undefined : function () {
      return onDiscard(campType, id);
    },
    onViewContact: type === _constants.TABS.WHATSAPP && campaign.type ? function () {
      return setContactInfoOpen(true);
    } : undefined,
    wrapUpTime: campaign.wrapUpTime,
    dispositions: campaign.dispositions,
    setWrapUpOpen: setWrapUpOpen,
    chatStarted: chatStarted,
    showWrapUp: campaign.showWrapUp === undefined ? true : campaign.showWrapUp,
    endConversation: endConversation,
    setEndConversation: setEndConversation,
    timeoutReached: timeoutReached,
    onDialog: type === _constants.TABS.WHATSAPP ? onDialog : undefined,
    disabledActions: disabledActions
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-conv-view"
  }, type === _constants.TABS.TWITTER ? /*#__PURE__*/_react["default"].createElement(_TwitterView["default"], {
    tweets: messages,
    user: contact
  }) : type === _constants.TABS.MAIL ? /*#__PURE__*/_react["default"].createElement(_MailsView["default"], {
    contact: _objectSpread(_objectSpread({}, contact), {}, {
      image: /*#__PURE__*/_react["default"].createElement(_ImageIcon["default"], {
        name: campaign.name,
        image: campaign.image,
        showTooltip: false
      })
    }),
    campaign: {
      name: campaign.senderName || campaign.name,
      account: campaign.account,
      image: /*#__PURE__*/_react["default"].createElement(_ImageIcon["default"], {
        icon: "user"
      })
    },
    mails: messages,
    draftMessages: draftMessages,
    openMails: openMessages,
    toggle: toggle,
    setWrapUpOpen: setWrapUpOpen,
    onReply: function onReply(messageId, subject, message, attachments, cc, bcc, IsAzure) {
      onHandleReply(messageId, subject, message, attachments, cc, bcc, IsAzure);
    },
    onDialog: onDialog,
    onUpdateDraftMessage: onUpdateDraftMessage,
    onUpdateDraftAttachments: onUpdateDraftAttachments,
    onAttachments: onAttachmentsHandle,
    onUploadAttachments: onUploadAttachmentsHandle,
    onDeleteAttachment: onDeleteAttachmentHandle,
    onDeleteDraftMessage: onDeleteDraftMessage,
    IsAzure: conversation.IsAzure ? conversation.IsAzure : false
  }) : /*#__PURE__*/_react["default"].createElement(_ChatView["default"], {
    lang: lang,
    contact: contact,
    agent: agent,
    disabled: disabled,
    disabledActions: disabledActions,
    type: type,
    userImage: /*#__PURE__*/_react["default"].createElement(_ImageIcon["default"], {
      name: campaign.name,
      image: campaign.image,
      type: campaign.type,
      showTooltip: false
    }),
    messages: messages,
    typing: typing,
    templates: templates,
    onSendResponse: function onSendResponse(message, attachments, type) {
      return _onSendResponse(campType, id, message, undefined, undefined, attachments, undefined, undefined, undefined, undefined, undefined, type);
    },
    onUnassign: onUnassign ? function () {
      return onUnassign(campType, id);
    } : undefined,
    onSpam: onSpam && type === _constants.TABS.WHATSAPP ? function () {
      return onSpam(campType, id);
    } : undefined,
    onFinish: onFinishHandler,
    onAceptedChat: type === _constants.TABS.WHATSAPP ? onAceptedChatHandle : undefined,
    show: type !== _constants.TABS.CHAT ? !chatStarted : false,
    setNumFiles: setNumFiles,
    onUploadAttachments: onUploadAttachmentsHandle,
    onDeleteAttachment: onDeleteAttachmentHandle,
    onShowAlertDisconexion: onShowAlertDisconexion,
    setTheUrlOfAttachments: setTheUrlOfAttachments,
    startConversation: startConversation,
    setStartConversation: setStartConversation,
    conversationId: id,
    onLoadMessages: type === _constants.TABS.WHATSAPP ? onLoadMessagesHandle : undefined,
    isEnableHistoricalChat: type === _constants.TABS.WHATSAPP ? clientWithHistoricalChat : false,
    isFetchingMessages: type === _constants.TABS.WHATSAPP ? lastConversations.fetching : false,
    isAllConversations: type === _constants.TABS.WHATSAPP ? lastConversations.isAllConversations : false,
    lastConversations: type === _constants.TABS.WHATSAPP ? lastConversations.conversationsDict || undefined : undefined,
    totalMessages: type === _constants.TABS.WHATSAPP ? messages.length : undefined,
    maxImgToSend: type === _constants.TABS.CHAT ? conversation.maxImgChat : undefined,
    onDialog: onDialog,
    getUploadState: getUploadState,
    campType: campaign.type
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'uin-conv-contact-info-wrapper' + (isContactInfoOpen ? ' open' : '')
  }, /*#__PURE__*/_react["default"].createElement(_ContactInfo["default"], {
    phoneNumber: contact.name,
    data: data,
    onClose: function onClose() {
      return setContactInfoOpen(false);
    },
    onFinish: onFinishHandler,
    onUnassign: type === _constants.TABS.WHATSAPP ? undefined : onUnassign ? function () {
      return onUnassign(campType, id);
    } : undefined
  })), /*#__PURE__*/_react["default"].createElement(_WrapUp["default"], {
    acdId: conversation.campaign.id,
    type: type,
    conversationId: conversation.id,
    show: isWrapUpOpen || clientTermination,
    toggle: function toggle() {
      return setWrapUpOpen(false);
    },
    onSelect: function onSelect(disposition) {
      onWrapUpHandler(disposition, mailResponseData.current.messageId);
      setTimeout(function () {
        if (type === 'MAIL') {
          _onSendResponse(campType, id, mailResponseData.current.message, mailResponseData.current.messageId, mailResponseData.current.subject, mailResponseData.current.attachments, conversation.campaign.account, conversation.contact.account, mailResponseData.current.cc, mailResponseData.current.bcc, mailResponseData.current.IsAzure);
        }
      }, 500);
    },
    time: conversation.campaign.wrapUpTime,
    dispositions: conversation.campaign.dispositions,
    closeModal: exitWrapUpDisposition === undefined ? true : exitWrapUpDisposition,
    onFinish: function onFinish() {
      return _onFinish(campType, id);
    }
  }));
};
ConversationView.propTypes = {
  conversation: _types.conversationType,
  openMessages: _propTypes["default"].arrayOf(_propTypes["default"].number),
  toggle: _propTypes["default"].func,
  onFinish: _propTypes["default"].func,
  onUnassign: _propTypes["default"].func,
  onSpam: _propTypes["default"].func,
  onDiscard: _propTypes["default"].func,
  onWrapUp: _propTypes["default"].func,
  onSendResponse: _propTypes["default"].func,
  onAceptedChat: _propTypes["default"].func,
  startConversation: _propTypes["default"].bool,
  setStartConversation: _propTypes["default"].func
};
var _default = exports["default"] = ConversationView;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/ConversationView/ConversationView.js
// module id = 1404
// module chunks = 0